var map = {
	"./arrow_normal_faq.svg": 7763,
	"./authform/hidden_password.svg": 3020,
	"./authform/hidden_password_click.svg": 8789,
	"./authform/hidden_password_focus.svg": 2006,
	"./authform/show_password.svg": 7600,
	"./authform/show_password_click.svg": 9369,
	"./authform/show_password_focus.svg": 8431,
	"./blog/copy-link.svg": 1863,
	"./blog/like.svg": 1730,
	"./blog/prev.svg": 4156,
	"./blog/share.svg": 1576,
	"./blog/show.svg": 3418,
	"./blog/telegram.svg": 1924,
	"./blog/thumb-down.svg": 8646,
	"./blog/thumb-up.svg": 2440,
	"./blog/vcontacte.svg": 9855,
	"./button-angle-white.svg": 2734,
	"./button-angle.svg": 2353,
	"./contacts/mail.svg": 9513,
	"./contacts/map.svg": 9411,
	"./contacts/phone.svg": 2525,
	"./corner-gray.svg": 3116,
	"./corner-white.svg": 4354,
	"./course/arrow.svg": 6716,
	"./course/arrow_active.svg": 7957,
	"./course/monitor_icon.svg": 6329,
	"./course/skill__icon.svg": 8855,
	"./delete/arrow-gradient.svg": 4778,
	"./delete/arrow-in-around.svg": 7778,
	"./delete/arrow.svg": 7809,
	"./delete/blog/like.svg": 9474,
	"./delete/blog/search.svg": 2301,
	"./delete/blog/show.svg": 8436,
	"./delete/courses-form-close.svg": 6720,
	"./delete/error-icons.svg": 6492,
	"./delete/logo.svg": 7482,
	"./delete/mail-form-focus.svg": 3619,
	"./delete/mail-form.svg": 5274,
	"./delete/mail.svg": 1769,
	"./delete/modal-caret-active.svg": 9533,
	"./delete/modal-caret.svg": 5427,
	"./delete/modal-checkbox-active.svg": 9039,
	"./delete/modal-checkbox.svg": 9614,
	"./delete/modal-mail-active.svg": 9436,
	"./delete/modal-mail.svg": 7361,
	"./delete/modal-phone-active.svg": 664,
	"./delete/modal-phone.svg": 5835,
	"./delete/modal-radio-active.svg": 2684,
	"./delete/modal-radio.svg": 9069,
	"./delete/modal-user-active.svg": 6695,
	"./delete/modal-user.svg": 1073,
	"./delete/phone-form-focus.svg": 5470,
	"./delete/phone-form.svg": 8578,
	"./delete/phone.svg": 5775,
	"./delete/user-focus.svg": 9162,
	"./delete/user.svg": 8366,
	"./delete/user_click.svg": 638,
	"./delete/user_focus.svg": 4211,
	"./footer/logo-fond.svg": 5133,
	"./footer/logo-vercont.svg": 3454,
	"./footer/logo_1t.svg": 646,
	"./freeLearn/free-learn-form.svg": 2886,
	"./freeLearn/free-learn-header1.svg": 5335,
	"./freeLearn/free-learn-header2.svg": 8507,
	"./freeLearn/free-learn-header3.svg": 5569,
	"./play.svg": 5590,
	"./rewiew-icon-user.svg": 693,
	"./stop.svg": 3523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;